namespace GeniuzPOS.Lookups {
    export interface LookupSubCategory2Row {
        SubCat2Code?: string;
        SubCat2Name?: string;
    }

    export namespace LookupSubCategory2Row {
        export const idProperty = 'SubCat2Code';
        export const nameProperty = 'SubCat2Code';
        export const localTextPrefix = 'Lookups.LookupSubCategory2';
        export const lookupKey = 'Lookups.LookupSubCategory2';

        export function getLookup(): Q.Lookup<LookupSubCategory2Row> {
            return Q.getLookup<LookupSubCategory2Row>('Lookups.LookupSubCategory2');
        }
        export const deletePermission = '*';
        export const insertPermission = '*';
        export const readPermission = '*';
        export const updatePermission = '*';

        export declare const enum Fields {
            SubCat2Code = "SubCat2Code",
            SubCat2Name = "SubCat2Name"
        }
    }
}
